import type { SvgIconProps } from '@mui/material/SvgIcon';
import SvgIcon from '@mui/material/SvgIcon';
import type { ReactNode } from 'react';

export function SignalsIcon(props: SvgIconProps): ReactNode {
  return (
    <SvgIcon viewBox="0 0 24 24" fill="none" {...props}>
      <circle cx="12" cy="12" r="2.4" fill="currentColor" />
      <path
        d="M7.5 7.5a6.4 6.4 0 0 0 0 9M16.5 7.5a6.4 6.4 0 0 1 0 9M4.7 4.7a10.3 10.3 0 0 0 0 14.6M19.3 4.7a10.3 10.3 0 0 1 0 14.6"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        fill="none"
      />
    </SvgIcon>
  );
}
